enum StvJaNeinUnbekannt {
    JA = "JA", NEIN = "NEIN", UNBEKANNT = "UNBEKANNT"
}

export default StvJaNeinUnbekannt;